export default __webpack_public_path__ + "static/media/BlueTreeCutebatman.294d78c6.jpg";